import { gql, useMutation } from "@apollo/client";

import {
  UpdateSKUInput,
  UpdateSKUMutation,
  UpdateSKUMutationVariables,
} from "../../../../../API";
import { UPDATE_SKU } from "../../../../../common/operations/mutations";
import { successNotification } from "../../../../../common/variables/notification";
import { handleApolloError } from "../../../../../common/utils/handleApolloError";

export const useUpdateSKU = () => {
  const [saveSKU, { data, loading }] = useMutation<
    UpdateSKUMutation,
    UpdateSKUMutationVariables
  >(UPDATE_SKU);

  const updateSKU = (input: UpdateSKUInput) => {
    return saveSKU({
      variables: {
        input,
      },
      onCompleted: response => {
        if (response.updateSKU) {
          successNotification("System template updated successfully");
        }
      },
      onError: handleApolloError,
      update: (cache, response): void => {
        const updated = response.data?.updateSKU;

        if (!updated) return;

        // Writing the fragment refreshes the normalized cache entry by id,
        // which propagates to the getSKUs list (items are stored as refs).
        cache.writeFragment({
          id: cache.identify(updated),
          fragment: gql`
            fragment UpdatedSKU on SKU {
              id
              skuNumber
              configurationName
              nodeCount
              skuDataConfigurations
              createdAt
            }
          `,
          data: updated,
        });
      },
    });
  };

  return { updateSKU, data, loading };
};
